import { Loader2, MailCheck, MailSearch, MailWarning, MailX } from "lucide-react";
import { EmailsType } from "../Emails";
import { useAllEmailSettings } from "@/hooks/useEmailSettings";

type EmailsMenuProps = {
  type: EmailsType;
  setType: (type: EmailsType) => void;
}
const menuItems: { type: string, icon: React.ElementType, label: EmailsType, description: string, isActive: boolean, timings?: {value: number, unit: "minutes" | "hours" | "days"}[] }[] =[
  {
    type: 'confirm',
    icon: MailCheck,
    label: "Email Confirmation",
    description: "Confirmation for created event",
    isActive: true,
  },
  {
    type: 'cancel',
    icon: MailX,
    label: "Email Cancellation",
    description: "Cancellation for cancelled event",
    isActive: true,
  },
  {
    type: 'follow_up',
    icon: MailSearch,
    label: "Email Follow-up",
    description: "Follow-up for event",
    isActive: true,
  },
  {
    type: 'reminder',
    icon: MailWarning,
    label: "Email Reminders",
    description: "Reminder for upcoming event",
    isActive: true,
    timings:[ {value: 1, unit: "minutes"}, {value: 1, unit: "hours"}, {value: 1, unit: "days"} ]
  },
  {
    type: 'pre_meeting',
    icon: MailWarning,
    label: "Pre-Call Email",
    description: "Reminder for upcoming event",
    isActive: true,
  },
]

export const EmailsMenu = ({ type, setType }: EmailsMenuProps) => {
  const { data: email, isLoading } = useAllEmailSettings();

  
  return (
    <div className="col-span-1">
      <div className="flex flex-col gap-2 flex-1 pr-2 py-4 space-y-1 ">
        {isLoading ? <div className="flex items-center justify-center h-full">
          <Loader2 className="w-4 h-4 animate-spin" />
        </div> : menuItems.map((item) => (
          <div onClick={() => setType(item.label)} key={item.label} className={`relative flex gap-3 px-3 py-2 text-sm cursor-pointer font-medium rounded-md transition-colors duration-150 ${
            type === item.label
              ? 'bg-primary text-primary-foreground shadow-sm'
              : 'text-secondary-foreground hover:bg-accent'
            }`}>
            <item.icon className="w-8  h-6 " />
            <div className="flex gap-1 flex-col">
              <p>{item.label}</p>
              {item.type === 'reminder' ? (
                <div className="flex flex-col gap-1">
                  {email['reminder']?.timings.map((timing: {value: number, unit: "minutes" | "hours" | "days"}) => (
                    <p key={timing.value} className={`text-xs font-thin ${type === item.label ? 'text-white' : 'text-black'}`}>- {timing.value} {timing.unit} before event</p>
                  ))}
                </div>
              ) : (
                <p className={`text-xs font-thin ${type === item.label ? 'text-white' : 'text-foreground'}`}>{item.description}</p>
              )}  
            </div>
            {!email[item.type]?.enabled && <div className="absolute right-2 text-xs top-2 text-secondary-foreground flex items-center gap-2 px-1 py-[2px] rounded bg-blue-100">
              Off
            </div>}
          </div>
        ))}
      </div>
    </div>
  )
}


